// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    overflow-y: scroll;
    scrollbar-gutter: stable;
}

:root {
  --h1: 1.25rem;

  --rank-strong: #eab308;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    background: var(--gray-50);
    color: var(--gray-900);
    line-height: 1.6;
}

@media (pointer: coarse) {
    input,
    select,
    textarea {
        font-size: 16px !important;
    }
}

.container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 2rem;
    padding-left: max(2rem, env(safe-area-inset-left));
    padding-right: max(2rem, env(safe-area-inset-right));
    padding-bottom: max(2rem, env(safe-area-inset-bottom));
    animation: app-fade-in 0.15s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: var(--bg-primary);
    border-bottom: 2px solid var(--primary);
    box-shadow: 0 1p 3px 0 rgba(0, 0, 0, 0.1);
    padding-top: env(safe-area-inset-top);
    animation: app-fade-in 0.15s ease-out;
}

.header-content {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 0.75rem 2rem;
    padding-left: max(2rem, env(safe-area-inset-left));
    padding-right: max(2rem, env(safe-area-inset-right));
    max-width: 1400px;
    margin: 0 auto;
}

.header-icon {
    flex-shrink: 0;
}

.header-icon svg {
    color: var(--primary);
    display: block;
}

header h1 {
    flex: 1;
    font-size: var(--h1);
    font-weight: 700;
    margin: 0;
    color: var(--text-primary);
}

.header-user {
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--text-secondary);
    margin-left: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.auth-panel {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.auth-status {
    color: var(--gray-600);
    font-size: 0.95rem;
}

.auth-status-muted {
    color: var(--gray-500);
}

.auth-button,
.auth-action {
    padding: 0.55rem 1rem;
    border-radius: 999px;
    border: 1px solid var(--gray-300);
    background: rgba(59, 130, 246, 0.08);
    color: var(--primary);
    font-weight: 600;
    transition: background 0.15s ease, transform 0.15s ease, border-color 0.15s ease;
}

.auth-button:hover,
.auth-action:hover {
    background: rgba(59, 130, 246, 0.16);
    border-color: rgba(37, 99, 235, 0.4);
}

.auth-button:active,
.auth-action:active {
    transform: translateY(1px);
}

.profile-settings {
    position: relative;
    display: inline-block;
}

.profile-settings-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s ease;
}

.profile-settings-trigger:hover {
    background: rgba(59, 130, 246, 0.1);
}

.profile-settings-popover {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: var(--bg-primary);
    border: 1px solid var(--gray-200);
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 260px;
    max-height: min(80vh, 560px);
    display: flex;
    flex-direction: column;
}

.profile-settings-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

.profile-settings-header {
    padding: 0.75rem 1rem;
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.02) 100%);
    border-bottom: 1px solid var(--gray-200);
}

.profile-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.profile-icon {
    font-size: 1.5rem;
    color: var(--primary);
    flex-shrink: 0;
}

.profile-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.profile-name {
    font-weight: 600;
    color: var(--gray-900);
    font-size: 0.95rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.profile-status {
    font-size: 0.75rem;
    color: var(--gray-500);
}

.profile-settings-divider {
    height: 1px;
    background: var(--gray-200);
}

.profile-settings-section {
    padding: 1rem;
    border-bottom: 1px solid var(--gray-200);
}

.profile-settings-section:last-of-type {
    border-bottom: none;
}

.profile-settings-label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--gray-600);
    margin-bottom: 0.75rem;
}

.profile-settings-section .theme-selector-wrapper,
.profile-settings-section .push-setup {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.profile-settings-fields {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.profile-settings-field {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.profile-settings-field .profile-settings-label {
    margin-bottom: 0;
}

.profile-settings-input {
    box-sizing: border-box;
    width: 100%;
    height: 2.25rem;
    padding: 0 0.75rem;
    border: 1px solid var(--gray-200);
    border-radius: 6px;
    font-size: 0.9rem;
    color: var(--text-primary);
    background: var(--bg-primary);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.profile-settings-input:hover {
    border-color: var(--gray-400);
}

.profile-settings-input:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.profile-settings-action {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
    width: 100%;
    padding: 0.75rem 1rem;
    background: transparent;
    border: none;
    border-radius: 0;
    color: var(--gray-900);
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
    text-align: left;
}

.profile-settings-action:hover {
    background: var(--gray-50);
    color: var(--primary);
}

.profile-settings-action:active {
    background: var(--gray-100);
    transform: none;
}

.profile-build-version {
    padding: 0.5rem 1rem 0.75rem;
    font-size: 0.65rem;
    color: var(--gray-400, '#9ca3af');
    text-align: center;
}

.theme-selector-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.theme-selector-current {
    font-size: 0.9rem;
    color: var(--gray-700);
    white-space: nowrap;
}

.theme-selector-current:hover {
    color: var(--primary);
}

.theme-selector-menu {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: var(--bg-primary);
    border: 1px solid var(--gray-200);
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    min-width: 160px;
    overflow: hidden;
}

.profile-settings-section .theme-selector-menu {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
}

.theme-selector-option {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.75rem 1rem;
    border: none;
    background: transparent;
    color: var(--gray-900);
    cursor: pointer;
    font-size: 0.9rem;
    text-align: left;
    transition: background 0.15s ease;
}

.theme-selector-option:hover {
    background: var(--gray-50);
}

.theme-selector-option[data-selected="true"] {
    background: rgba(37, 99, 235, 0.08);
    color: var(--primary);
    font-weight: 600;
}

.theme-color-dot {
    width: 14px;
    flex-shrink: 0;
    text-align: center;
}

.nav-profile-settings .profile-settings-trigger {
    width: auto;
    padding: 0.5rem 0.75rem;
    border: 1px solid var(--gray-300);
    background: rgba(37, 99, 235, 0.05);
}

.nav-profile-settings .profile-settings-popover {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    left: auto;
    width: min(320px, 100%);
    max-width: 90vw;
    border-radius: 8px;
    border: 1px solid var(--gray-200);
}

.nav-toggle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 36px;
    height: 36px;
    padding: 6px 5px;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s ease;
}

.nav-toggle:hover {
    background: var(--gray-100);
}

.nav-toggle span {
    display: block;
    width: 100%;
    height: 2px;
    background: var(--gray-700);
    border-radius: 999px;
    transition: transform 0.25s ease, opacity 0.2s ease, background 0.15s ease;
    transform-origin: center;
}

.nav-toggle:hover span,
.nav-toggle[aria-expanded="true"] span {
    background: var(--primary);
}

.nav-toggle[aria-expanded="true"] span:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
}

.nav-toggle[aria-expanded="true"] span:nth-child(2) {
    opacity: 0;
    transform: scaleX(0);
}

.nav-toggle[aria-expanded="true"] span:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
}

.nav-drawer {
    background: var(--bg-primary);
    border-top: 1px solid var(--gray-200);
    box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.12);
}

.nav-drawer-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding: 0.75rem 2rem;
    max-width: 1400px;
    margin: 0 auto;
    flex-wrap: wrap;
}

.nav-label {
    font-size: calc(var(--h1) * 0.7);
    font-weight: 500;
    color: var(--gray-600);
}

.nav-section-divider {
    width: 100%;
    height: 1px;
    background: var(--gray-200);
    margin: 0.75rem 0;
}

.nav-link {
    background: transparent;
    border: none;
    color: var(--primary);
    cursor: pointer;
    font-size: 0.95rem;
    text-align: left;
    padding: 0.45rem 0;
    width: 100%;
}

.nav-link:hover {
    text-decoration: underline;
}

main {
    display: grid;
    gap: 1.5rem;
}

main > * {
    min-width: 0;
}

main > .guest-banner,
main > .notification-banner,
main > .offline-banner,
main > .update-banner,
main > .auth-service-banner {
    grid-column: 1 / -1;
}

.sidebar-column {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.card {
    background: var(--bg-primary);
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid var(--gray-200);
    min-width: 0;
}

.section-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.section-header h2 {
    min-width: 0;
    flex-shrink: 1;
}

.contact-form {
    display: grid;
    gap: 1rem;
}

.contact-form label {
    display: grid;
    gap: 0.5rem;
    font-weight: 500;
}

.required-asterisk {
  color: var(--danger);
  position: relative;
}

.contact-form input::placeholder,
.contact-form textarea::placeholder {
    font-size: 1em;
    opacity: 0.7;
}

.contact-form input,
.contact-form textarea {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 1px solid var(--gray-200);
    border-radius: 8px;
    background: var(--bg-secondary);
    color: inherit;
    resize: vertical;
    font-size: clamp(14px, 2vw, 16px);
}

.contact-form textarea {
    min-height: 150px;
}

h2 {
    color: var(--gray-900);
    font-size: calc(var(--h1) * 1.2);
    font-weight: 700;
    margin: 0;
}

input[type="text"] {
    flex: 1;
    padding: 0.625rem 0.875rem;
    border: 1px solid var(--gray-300);
    border-radius: 6px;
    font-size: calc(var(--h1) * 0.75);
    color: var(--gray-900);
    background: var(--bg-primary);
    transition: all 0.15s ease;
}

input[type="text"]:hover {
    border-color: var(--gray-400);
}

input[type="text"]:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

button {
    padding: 0.625rem 1.25rem;
    background: var(--primary);
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: calc(var(--h1) * 0.75);
    font-weight: 500;
    transition: background 0.15s ease;
    white-space: nowrap;
}

button:hover {
    background: var(--primary-dark);
}

button:active {
    transform: scale(0.98);
}

.push-setup {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
}

.push-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    user-select: none;
}

.push-toggle input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    border: 0;
}

.push-toggle-track {
    position: relative;
    width: 34px;
    height: 18px;
    border-radius: 999px;
    background: var(--gray-300);
    transition: background 0.2s ease;
    flex-shrink: 0;
}

.push-toggle-thumb {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
    transition: transform 0.2s ease;
}

.push-toggle-active .push-toggle-track {
    background: var(--primary);
}

.push-toggle-active .push-toggle-thumb {
    transform: translateX(16px);
}

.push-toggle input:focus + .push-toggle-track {
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
}

.push-toggle input:disabled + .push-toggle-track {
    opacity: 0.7;
    cursor: default;
}

.push-toggle-text {
    font-size: 0.82rem;
    color: var(--gray-900);
}

.btn-save {
    background: var(--success);
}

.btn-save:hover {
    background: #047857;
}

.btn-export {
    background: var(--warning);
}

.btn-export:hover {
    background: #c2410c;
}

.btn-notifications {
    color: var(--danger);
}

.btn-view {
    color: var(--primary);
}

.btn-tag {
    color: var(--primary);
}

.btn-fetch {
    color: var(--primary);
    background: var(--gray-100);
}

.btn-fetch:hover {
    background: var(--gray-200);
}

.btn-close {
    color: var(--gray-500);
}

.btn-close:hover {
    color: var(--primary);
}

.btn-clear {
    background: var(--danger);
}

.btn-clear:hover {
    background: #b91c1c;
}

.btn-refresh {
    background: var(--info);
}

.btn-refresh:hover {
    background: #0e7490;
}

.btn-ghost {
    background: transparent !important;
    border: none !important;
    transition: background 0.15s ease, filter 0.15s ease !important;
}

.btn-ghost:hover:not(:disabled) {
    background: rgba(128, 128, 128, 0.1) !important;
    filter: brightness(1.2);
}

.btn-ghost:active:not(:disabled) {
    background: rgba(128, 128, 128, 0.2) !important;
    transform: scale(0.95);
}
`, "",{"version":3,"sources":["webpack://./src/renderer/styles/base.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;EACE,aAAa;;EAEb,sBAAsB;AACxB;;AAEA;IACI,uGAAuG;IACvG,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI;;;QAGI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,kDAAkD;IAClD,oDAAoD;IACpD,sDAAsD;IACtD,qCAAqC;AACzC;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,6BAA6B;IAC7B,uCAAuC;IACvC,yCAAyC;IACzC,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,kDAAkD;IAClD,oDAAoD;IACpD,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;IACpB,iCAAiC;IACjC,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;IAChB,gFAAgF;AACpF;;AAEA;;IAEI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,6FAA6F;IAC7F,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;IAC7B,0DAA0D;AAC9D;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;IACpB,0EAA0E;IAC1E,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;IAKI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,0CAA0C;IAC1C,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;IAEI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,iCAAiC;IACjC,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,OAAO;IACP,0BAA0B;IAC1B,iCAAiC;IACjC,kBAAkB;IAClB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;IAC3B,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,+DAA+D;AACnE;;AAEA;IACI,+CAA+C;IAC/C,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    overflow-y: scroll;\n    scrollbar-gutter: stable;\n}\n\n:root {\n  --h1: 1.25rem;\n\n  --rank-strong: #eab308;\n}\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n    background: var(--gray-50);\n    color: var(--gray-900);\n    line-height: 1.6;\n}\n\n@media (pointer: coarse) {\n    input,\n    select,\n    textarea {\n        font-size: 16px !important;\n    }\n}\n\n.container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 2rem;\n    padding-left: max(2rem, env(safe-area-inset-left));\n    padding-right: max(2rem, env(safe-area-inset-right));\n    padding-bottom: max(2rem, env(safe-area-inset-bottom));\n    animation: app-fade-in 0.15s ease-out;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\nheader {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background: var(--bg-primary);\n    border-bottom: 2px solid var(--primary);\n    box-shadow: 0 1p 3px 0 rgba(0, 0, 0, 0.1);\n    padding-top: env(safe-area-inset-top);\n    animation: app-fade-in 0.15s ease-out;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    gap: 0.875rem;\n    padding: 0.75rem 2rem;\n    padding-left: max(2rem, env(safe-area-inset-left));\n    padding-right: max(2rem, env(safe-area-inset-right));\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.header-icon {\n    flex-shrink: 0;\n}\n\n.header-icon svg {\n    color: var(--primary);\n    display: block;\n}\n\nheader h1 {\n    flex: 1;\n    font-size: var(--h1);\n    font-weight: 700;\n    margin: 0;\n    color: var(--text-primary);\n}\n\n.header-user {\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    margin-left: 0.5rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.auth-panel {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n}\n\n.auth-status {\n    color: var(--gray-600);\n    font-size: 0.95rem;\n}\n\n.auth-status-muted {\n    color: var(--gray-500);\n}\n\n.auth-button,\n.auth-action {\n    padding: 0.55rem 1rem;\n    border-radius: 999px;\n    border: 1px solid var(--gray-300);\n    background: rgba(59, 130, 246, 0.08);\n    color: var(--primary);\n    font-weight: 600;\n    transition: background 0.15s ease, transform 0.15s ease, border-color 0.15s ease;\n}\n\n.auth-button:hover,\n.auth-action:hover {\n    background: rgba(59, 130, 246, 0.16);\n    border-color: rgba(37, 99, 235, 0.4);\n}\n\n.auth-button:active,\n.auth-action:active {\n    transform: translateY(1px);\n}\n\n.profile-settings {\n    position: relative;\n    display: inline-block;\n}\n\n.profile-settings-trigger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.profile-settings-trigger:hover {\n    background: rgba(59, 130, 246, 0.1);\n}\n\n.profile-settings-popover {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background: var(--bg-primary);\n    border: 1px solid var(--gray-200);\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    min-width: 260px;\n    max-height: min(80vh, 560px);\n    display: flex;\n    flex-direction: column;\n}\n\n.profile-settings-scroll {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n}\n\n.profile-settings-header {\n    padding: 0.75rem 1rem;\n    background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.02) 100%);\n    border-bottom: 1px solid var(--gray-200);\n}\n\n.profile-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.profile-icon {\n    font-size: 1.5rem;\n    color: var(--primary);\n    flex-shrink: 0;\n}\n\n.profile-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.profile-name {\n    font-weight: 600;\n    color: var(--gray-900);\n    font-size: 0.95rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.profile-status {\n    font-size: 0.75rem;\n    color: var(--gray-500);\n}\n\n.profile-settings-divider {\n    height: 1px;\n    background: var(--gray-200);\n}\n\n.profile-settings-section {\n    padding: 1rem;\n    border-bottom: 1px solid var(--gray-200);\n}\n\n.profile-settings-section:last-of-type {\n    border-bottom: none;\n}\n\n.profile-settings-label {\n    display: block;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--gray-600);\n    margin-bottom: 0.75rem;\n}\n\n.profile-settings-section .theme-selector-wrapper,\n.profile-settings-section .push-setup {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.profile-settings-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.profile-settings-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.profile-settings-field .profile-settings-label {\n    margin-bottom: 0;\n}\n\n.profile-settings-input {\n    box-sizing: border-box;\n    width: 100%;\n    height: 2.25rem;\n    padding: 0 0.75rem;\n    border: 1px solid var(--gray-200);\n    border-radius: 6px;\n    font-size: 0.9rem;\n    color: var(--text-primary);\n    background: var(--bg-primary);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.profile-settings-input:hover {\n    border-color: var(--gray-400);\n}\n\n.profile-settings-input:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.profile-settings-action {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.75rem;\n    width: 100%;\n    padding: 0.75rem 1rem;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    color: var(--gray-900);\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n    text-align: left;\n}\n\n.profile-settings-action:hover {\n    background: var(--gray-50);\n    color: var(--primary);\n}\n\n.profile-settings-action:active {\n    background: var(--gray-100);\n    transform: none;\n}\n\n.profile-build-version {\n    padding: 0.5rem 1rem 0.75rem;\n    font-size: 0.65rem;\n    color: var(--gray-400, '#9ca3af');\n    text-align: center;\n}\n\n.theme-selector-wrapper {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.theme-selector-current {\n    font-size: 0.9rem;\n    color: var(--gray-700);\n    white-space: nowrap;\n}\n\n.theme-selector-current:hover {\n    color: var(--primary);\n}\n\n.theme-selector-menu {\n    position: absolute;\n    top: calc(100% + 4px);\n    right: 0;\n    background: var(--bg-primary);\n    border: 1px solid var(--gray-200);\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 1001;\n    min-width: 160px;\n    overflow: hidden;\n}\n\n.profile-settings-section .theme-selector-menu {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 4px);\n}\n\n.theme-selector-option {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: none;\n    background: transparent;\n    color: var(--gray-900);\n    cursor: pointer;\n    font-size: 0.9rem;\n    text-align: left;\n    transition: background 0.15s ease;\n}\n\n.theme-selector-option:hover {\n    background: var(--gray-50);\n}\n\n.theme-selector-option[data-selected=\"true\"] {\n    background: rgba(37, 99, 235, 0.08);\n    color: var(--primary);\n    font-weight: 600;\n}\n\n.theme-color-dot {\n    width: 14px;\n    flex-shrink: 0;\n    text-align: center;\n}\n\n.nav-profile-settings .profile-settings-trigger {\n    width: auto;\n    padding: 0.5rem 0.75rem;\n    border: 1px solid var(--gray-300);\n    background: rgba(37, 99, 235, 0.05);\n}\n\n.nav-profile-settings .profile-settings-popover {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    left: auto;\n    width: min(320px, 100%);\n    max-width: 90vw;\n    border-radius: 8px;\n    border: 1px solid var(--gray-200);\n}\n\n.nav-toggle {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 5px;\n    width: 36px;\n    height: 36px;\n    padding: 6px 5px;\n    background: transparent;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background 0.15s ease;\n}\n\n.nav-toggle:hover {\n    background: var(--gray-100);\n}\n\n.nav-toggle span {\n    display: block;\n    width: 100%;\n    height: 2px;\n    background: var(--gray-700);\n    border-radius: 999px;\n    transition: transform 0.25s ease, opacity 0.2s ease, background 0.15s ease;\n    transform-origin: center;\n}\n\n.nav-toggle:hover span,\n.nav-toggle[aria-expanded=\"true\"] span {\n    background: var(--primary);\n}\n\n.nav-toggle[aria-expanded=\"true\"] span:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n}\n\n.nav-toggle[aria-expanded=\"true\"] span:nth-child(2) {\n    opacity: 0;\n    transform: scaleX(0);\n}\n\n.nav-toggle[aria-expanded=\"true\"] span:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n}\n\n.nav-drawer {\n    background: var(--bg-primary);\n    border-top: 1px solid var(--gray-200);\n    box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.12);\n}\n\n.nav-drawer-content {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding: 0.75rem 2rem;\n    max-width: 1400px;\n    margin: 0 auto;\n    flex-wrap: wrap;\n}\n\n.nav-label {\n    font-size: calc(var(--h1) * 0.7);\n    font-weight: 500;\n    color: var(--gray-600);\n}\n\n.nav-section-divider {\n    width: 100%;\n    height: 1px;\n    background: var(--gray-200);\n    margin: 0.75rem 0;\n}\n\n.nav-link {\n    background: transparent;\n    border: none;\n    color: var(--primary);\n    cursor: pointer;\n    font-size: 0.95rem;\n    text-align: left;\n    padding: 0.45rem 0;\n    width: 100%;\n}\n\n.nav-link:hover {\n    text-decoration: underline;\n}\n\nmain {\n    display: grid;\n    gap: 1.5rem;\n}\n\nmain > * {\n    min-width: 0;\n}\n\nmain > .guest-banner,\nmain > .notification-banner,\nmain > .offline-banner,\nmain > .update-banner,\nmain > .auth-service-banner {\n    grid-column: 1 / -1;\n}\n\n.sidebar-column {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.card {\n    background: var(--bg-primary);\n    border-radius: 8px;\n    padding: 2rem;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    border: 1px solid var(--gray-200);\n    min-width: 0;\n}\n\n.section-header {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.section-header h2 {\n    min-width: 0;\n    flex-shrink: 1;\n}\n\n.contact-form {\n    display: grid;\n    gap: 1rem;\n}\n\n.contact-form label {\n    display: grid;\n    gap: 0.5rem;\n    font-weight: 500;\n}\n\n.required-asterisk {\n  color: var(--danger);\n  position: relative;\n}\n\n.contact-form input::placeholder,\n.contact-form textarea::placeholder {\n    font-size: 1em;\n    opacity: 0.7;\n}\n\n.contact-form input,\n.contact-form textarea {\n    width: 100%;\n    padding: 0.85rem 1rem;\n    border: 1px solid var(--gray-200);\n    border-radius: 8px;\n    background: var(--bg-secondary);\n    color: inherit;\n    resize: vertical;\n    font-size: clamp(14px, 2vw, 16px);\n}\n\n.contact-form textarea {\n    min-height: 150px;\n}\n\nh2 {\n    color: var(--gray-900);\n    font-size: calc(var(--h1) * 1.2);\n    font-weight: 700;\n    margin: 0;\n}\n\ninput[type=\"text\"] {\n    flex: 1;\n    padding: 0.625rem 0.875rem;\n    border: 1px solid var(--gray-300);\n    border-radius: 6px;\n    font-size: calc(var(--h1) * 0.75);\n    color: var(--gray-900);\n    background: var(--bg-primary);\n    transition: all 0.15s ease;\n}\n\ninput[type=\"text\"]:hover {\n    border-color: var(--gray-400);\n}\n\ninput[type=\"text\"]:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\nbutton {\n    padding: 0.625rem 1.25rem;\n    background: var(--primary);\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: calc(var(--h1) * 0.75);\n    font-weight: 500;\n    transition: background 0.15s ease;\n    white-space: nowrap;\n}\n\nbutton:hover {\n    background: var(--primary-dark);\n}\n\nbutton:active {\n    transform: scale(0.98);\n}\n\n.push-setup {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.push-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    user-select: none;\n}\n\n.push-toggle input {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n.push-toggle-track {\n    position: relative;\n    width: 34px;\n    height: 18px;\n    border-radius: 999px;\n    background: var(--gray-300);\n    transition: background 0.2s ease;\n    flex-shrink: 0;\n}\n\n.push-toggle-thumb {\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: white;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n    transition: transform 0.2s ease;\n}\n\n.push-toggle-active .push-toggle-track {\n    background: var(--primary);\n}\n\n.push-toggle-active .push-toggle-thumb {\n    transform: translateX(16px);\n}\n\n.push-toggle input:focus + .push-toggle-track {\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n}\n\n.push-toggle input:disabled + .push-toggle-track {\n    opacity: 0.7;\n    cursor: default;\n}\n\n.push-toggle-text {\n    font-size: 0.82rem;\n    color: var(--gray-900);\n}\n\n.btn-save {\n    background: var(--success);\n}\n\n.btn-save:hover {\n    background: #047857;\n}\n\n.btn-export {\n    background: var(--warning);\n}\n\n.btn-export:hover {\n    background: #c2410c;\n}\n\n.btn-notifications {\n    color: var(--danger);\n}\n\n.btn-view {\n    color: var(--primary);\n}\n\n.btn-tag {\n    color: var(--primary);\n}\n\n.btn-fetch {\n    color: var(--primary);\n    background: var(--gray-100);\n}\n\n.btn-fetch:hover {\n    background: var(--gray-200);\n}\n\n.btn-close {\n    color: var(--gray-500);\n}\n\n.btn-close:hover {\n    color: var(--primary);\n}\n\n.btn-clear {\n    background: var(--danger);\n}\n\n.btn-clear:hover {\n    background: #b91c1c;\n}\n\n.btn-refresh {\n    background: var(--info);\n}\n\n.btn-refresh:hover {\n    background: #0e7490;\n}\n\n.btn-ghost {\n    background: transparent !important;\n    border: none !important;\n    transition: background 0.15s ease, filter 0.15s ease !important;\n}\n\n.btn-ghost:hover:not(:disabled) {\n    background: rgba(128, 128, 128, 0.1) !important;\n    filter: brightness(1.2);\n}\n\n.btn-ghost:active:not(:disabled) {\n    background: rgba(128, 128, 128, 0.2) !important;\n    transform: scale(0.95);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
